import styled from "styled-components";

export const ContainerStyled = styled.div`
  box-sizing: border-box;
  padding: 0 24px;
  position: relative;
  margin: 0 auto;
  display: block;
  height: 100%;
  width: 100%;

  & .section-title {
    text-align: center;
    font-size: 2.5rem;
    font-weight: 500;
    margin: 80px 0;
    letter-spacing: 1px;

    @media screen and (max-width: 1200px) {
      font-size: 2.1rem;
    }
    @media screen and (max-width: 991px) {
      margin: 50px 0;
      font-size: 1.7rem;
    }
    @media screen and (max-width: 767px) {
      margin: 30px 0;
      font-size: 1.3rem;
    }
  }

  @media screen and (min-width: 1440px) {
    max-width: 1400px;
    padding: 0;
  }

  @media screen and (min-width: 1280px) and (max-width: 1439px) {
    max-width: 1280px;
    padding: 0 16px;
  }

  @media screen and (min-width: 1024px) and (max-width: 1279px) {
    max-width: 1024px;
    padding: 0 16px;
  }

  @media screen and (min-width: 768px) and (max-width: 1023px) {
    max-width: 768px;
    padding: 0 12px;
  }

  @media screen and (max-width: 767px) {
    max-width: 100vw;
    width: 100%;
    padding: 0 8px;
    overflow: hidden;
  }
`;
